const eurFmt = new Intl.NumberFormat('de-DE', {
  style: 'currency',
  currency: 'EUR',
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
})

const piecesFmt = new Intl.NumberFormat('de-DE', {
  minimumFractionDigits: 0,
  maximumFractionDigits: 4,
})

export function fmtEur(v) {
  if (v === null || v === undefined || isNaN(v)) return '—'
  return eurFmt.format(v)
}

export function fmtSignedEur(v) {
  if (v === null || v === undefined || isNaN(v)) return '—'
  const sign = v >= 0 ? '+' : ''
  return sign + eurFmt.format(v)
}

export function fmtPct(v) {
  if (v === null || v === undefined || isNaN(v)) return '—'
  const pct = v * 100
  const sign = pct >= 0 ? '+' : ''
  return `${sign}${pct.toFixed(2)} %`
}

export function fmtPieces(v) {
  if (v === null || v === undefined || isNaN(v)) return '—'
  return piecesFmt.format(v)
}

export function fmtDate(iso) {
  if (!iso) return '—'
  const d = new Date(iso)
  if (isNaN(d.getTime())) return '—'
  return d.toLocaleDateString('de-DE', {year: 'numeric', month: '2-digit', day: '2-digit'})
}

export function gainClass(v) {
  if (v === null || v === undefined || isNaN(v) || v === 0) return ''
  return v > 0 ? 'green--text text--darken-2' : 'red--text text--darken-2'
}
